// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_chevron_down from '../../img/icons/24/chevron_down.svg';
import {perr} from 'hola_pub_util';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Button} from '../../lib/button';
import {Logo} from '../../lib/logo';
import {product_pages, products} from '../products';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';
import styles from './footer.module.less';

type t_header_group = {
    header: string;
    header_url?: string;
    togglable: boolean;
    new_tab?: boolean;
    links: {url?: string; text: React.ReactNode;}[];
};

const {SHARED_ISP, ISPPREM, SDC, DDC, RES, EV_ISP, SNK, EV_RES} = Proxy_type;
const MENU_LINKS: t_header_group[] = [
    {
        header: 'Products',
        header_url: get_new_link('/pricing'),
        togglable: true,
        links: [SHARED_ISP, ISPPREM, EV_ISP, SDC, DDC, RES, SNK,
            EV_RES].map(p=>({
                url: get_new_link(product_pages[p]),
                text: products[p],
        })),
    },
    {
        header: 'Locations',
        header_url: get_new_link('/proxy-location'),
        togglable: true,
        links: [
            {
                text: 'United States proxies',
                url: get_new_link('/proxy-location/us'),
            },
            {
                text: 'Canada proxies',
                url: get_new_link('/proxy-location/ca'),
            },
            {
                text: 'Germany proxies',
                url: get_new_link('/proxy-location/de'),
            },
            {
                text: 'United Kingdom proxies',
                url: get_new_link('/proxy-location/uk'),
            },
            {
                text: 'France proxies',
                url: get_new_link('/proxy-location/fr'),
            },
        ],
    },
    {
        header: 'Company',
        header_url: get_new_link('/legal'),
        togglable: true,
        links: [
            {
                url: 'https://oculusproxies.com/blog/',
                text: 'Blog',
            },
            {
                url: 'https://oculusntwrks.ositracker.com/myrefer',
                text: 'Affiliates',
            },
            {
                url: get_new_link('/legal/terms_conditions'),
                text: 'Terms and conditions',
            },
            {
                url: get_new_link('/legal/privacy_policy'),
                text: 'Privacy Policy',
            },
            {
                url: get_new_link('/legal/refund_policy'),
                text: 'Refund Policy',
            },
        ],
    },
    {
        header: 'Contact',
        togglable: true,
        links: [
            {
                url: 'https://discord.com/invite/eNew2hGGru',
                text: 'Join Our Discord',
            },
            {
                url: 'mailto:support@oculusproxies.com',
                text: 'support@oculusproxies.com',
            },
        ],
    },
];

const Copyright = ()=>{
    const {theme} = use_theme();
    return <div className={styles.copyright}>
      <Logo dark/>
      <p className={theme.p12}>Oculus Networks Inc. 1013 Centre Road Suite 403
        B Wilmington DE 19805</p>
      <p className={theme.p12}>Oculus Networks Inc &copy; 2025</p>
    </div>;
};

const Menu_group = ({group}: {group: t_header_group;})=>{
    const [show, set_show] = useState(!group.togglable);
    const {theme} = use_theme();
    return <div className={cn(styles.group, !show && styles.hidden)}>
      <p className={cn(styles.group_header, theme.P, theme.med,
        group.header_url && styles.group_header_with_url,
        group.togglable && styles.group_header_togglable)}
        onClick={()=>set_show(x=>!x)}
      >
        {!!group.header_url && <a
          href={group.header_url}
          className={cn(theme.p14, theme.med, theme.P, styles.header_url)}
          target={group.new_tab ? '_blank' : undefined}
          rel={group.new_tab ? 'noopener noreferrer' : undefined}>
          {group.header}
        </a>}
        <span className={styles.header_text}>{group.header}</span>
        {!!group.togglable &&
            <Icon_chevron_down className={styles.arrow}/>}
      </p>
      <div className={styles.elems}>
        {group.links.map(({url, text}, idx)=>
        <p key={url ?? idx}
          className={cn(styles.elem, theme.p14, theme.med)}>{!url ? text :
            <a key={url} href={url}
              className={cn(theme.P, theme.p14, theme.med)}
              target={group.new_tab ? '_blank' : undefined}
              rel={group.new_tab ? 'noopener noreferrer' : undefined}>
              {text}
            </a>}
        </p>)}
      </div>
    </div>;
};

interface i_oculus_footer_props {
    hide_cta?: boolean;
}

export const Oculus_footer = ({hide_cta}: i_oculus_footer_props)=>{
    const {width} = use_screen();
    const {show_free_zone_promo} = use_app_context();
    const cta_text = show_free_zone_promo ? 'Try now for free' : 'Try now';
    return <div className={styles.footer}>
      <div className={styles.bg}/>
      <div className={styles.wrapper}>
        {!hide_cta && <div className={cn(styles.content, styles.footer_top)}>
          <div className={styles.title}>
            <span>Best Proxies. </span>
            <span>Best Prices.</span>
          </div>
          <Button caption={<>{cta_text}</>}
            size={width < 768 ? 'm' : 'l'} to={'/dashboard'}
            on_click={()=>{ perr({id: 'oculus_footer_cta_click'}); }}
            cls={styles.cta}
          />
        </div>}
        <div className={cn(styles.content, styles.menu)}>
          {MENU_LINKS.map(group=><Menu_group key={group.header}
            group={group}/>)}
        </div>
        <div className={cn(styles.content, styles.footer_bot)}>
          <div className={styles.separator}/>
          <Copyright/>
        </div>
      </div>
    </div>;
};
